module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18335/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"